import { ITextProps, Text } from '@fluentui/react'
import * as React from 'react'
import { ReactElement } from 'react'

type Props = {
    value?: string
    textProps?: ITextProps
}

export default function TimeText({ value, textProps }: Props): ReactElement {
    if (!value) {
        return <></>
    }

    const parts = (value || '').split(':')
    const text = (
        <>
            {parts[0]}
            <small>:{parts[1]}</small>
        </>
    )

    return textProps ? <Text {...textProps}>{text}</Text> : text
}
